import { render, staticRenderFns } from "./examine-approve-modal.vue?vue&type=template&id=2125d9b4&scoped=true"
import script from "./examine-approve-modal.vue?vue&type=script&lang=js"
export * from "./examine-approve-modal.vue?vue&type=script&lang=js"
import style0 from "./examine-approve-modal.vue?vue&type=style&index=0&id=2125d9b4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2125d9b4",
  null
  
)

export default component.exports